import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { defaultContext, getInitialStyle, getStateLetterStyles, buttonColor } from './keyItem.style';

export class KeyboardItem extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Button: {
          shader: {
            type: Lightning.shaders.RoundedRectangle,
          },
          SpecialIndicator: {
            visible: false,
            shader: {
              type: Lightning.shaders.RoundedRectangle,
            },
          },
        },
      },
      getInitialStyle(),
    );
  }

  _setup() {
    this._style = defaultContext;
  }

  static _states() {
    return [
      class Unfocused extends this {
        $enter() {
          if (this.tag('Icon')) {
            this.tag('Button').color = buttonColor.iconBackgroundUnFocused[this._style.colorMode];
            this.tag('Icon').color = buttonColor.innerElementUnFocused[this._style.colorMode];

            return;
          }
          this.tag('Button').color = buttonColor.backgroundUnFocused[this._style.colorMode];
          this.tag('Letter').text = getStateLetterStyles(this._style).unfocused;
        }
      },
      class Focused extends this {
        $enter() {
          this.tag('Button').color = buttonColor.backgroundFocused[this._style.colorMode];
          if (this.tag('Letter')) this.tag('Letter').text = getStateLetterStyles(this._style).focused;
          if (this.tag('Icon')) this.tag('Icon').color = buttonColor.innerElementFocused[this._style.colorMode];
        }
      },
    ];
  }

  _focus() {
    this._setState('Focused');
  }

  _unfocus() {
    this._setState('Unfocused');
  }
}
